import { useState, useEffect, useCallback } from "react";
import { getSectionByStatusURL } from "../../utils/ConstantsURL";

export const useFetchSectionsByStatus = (token, documentId) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const fetchByStatus = useCallback(async (status) => {
    setLoading(true);
    setError(null);
    try {
      const bodyParams = { documentId };
      if (status !== undefined) {
        bodyParams.flgStatus = status;
      }
      
      const response = await fetch(getSectionByStatusURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(bodyParams),
      });

      const data = await response.json();
      if (response.ok) {
        setLoading(false);
        return data.data;
      } else {
        throw new Error(data.message || "Error desconocido");
      }
    } catch (err) {
      setLoading(false);
      setError(err);
      console.error("Error fetching sections by status:", err);
      return null;
    }
  }, [token, documentId]);

  const refresh = useCallback(() => {
    setRefreshIndex((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (!token || !documentId) return;

    let isMounted = true;
    const fetchAll = async () => {
      const data = await fetchByStatus(undefined);
      if (isMounted && data) {
        setSections(data);
      }
    };

    fetchAll();

    return () => {
      isMounted = false;
    };
  }, [token, documentId, refreshIndex, fetchByStatus]);

  return { sections, loading, error, refresh, fetchByStatus };
};
